module.exports = __webpack_public_path__ + "img/banner2.614bfbe2.jpg";